// extracted by mini-css-extract-plugin
export default {"circle":"MessageCenterContainer-module_circle_JtUXya9CYO","iconPadding":"MessageCenterContainer-module_iconPadding_jl1AJ9QK_x"};